/** 近 30 天走势（堆叠柱状图） */ export const getGmvTrendOption = (param, t)=>{
    let { days, silentSeries, receptionSeries } = param;
    return {
        tooltip: {
            trigger: 'axis',
            appendToBody: true,
            axisPointer: {
                type: 'shadow'
            },
            extraCssText: 'padding: 10px 14px; line-height: 1.8; font-size: 13px;',
            textStyle: {
                fontSize: 13
            },
            formatter: (params)=>{
                var _params_;
                const date = (params === null || params === void 0 ? void 0 : (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.axisValue) ?? '';
                const rows = params.map((p)=>`<span style="
						display:inline-block;
						width:6px;
						height:6px;
						border-radius:50%;
						background:${p.color};
						margin-right:6px;
					"></span>
					${p.seriesName}：${Number(p.value).toFixed(2)}${t('c_a_overview_labor_currency1')}`).join('<br/>');
                return `${date}<br/>${rows}`;
            }
        },
        legend: {
            top: 0,
            right: 0,
            itemWidth: 6,
            itemHeight: 6,
            itemGap: 16,
            icon: 'circle',
            textStyle: {
                fontSize: 12,
                color: '#697386'
            }
        },
        grid: {
            left: 6,
            right: 6,
            top: 30,
            bottom: 0,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: days,
            axisLine: {
                lineStyle: {
                    color: '#eef1f6'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                fontSize: 11,
                color: '#a7afbd',
                interval: 'auto'
            }
        },
        yAxis: {
            type: 'value',
            name: t('c_a_overview_gmv_description_14'),
            nameTextStyle: {
                fontSize: 11,
                color: '#a7afbd'
            },
            splitLine: {
                lineStyle: {
                    color: '#f1f3f7'
                }
            },
            axisLabel: {
                fontSize: 11,
                color: '#a7afbd'
            }
        },
        series: [
            {
                name: t('c_a_overview_gmv_silence'),
                type: 'bar',
                stack: 'gmv',
                barMaxWidth: 10,
                data: silentSeries,
                itemStyle: {
                    color: '#6CE565'
                }
            },
            {
                name: t('c_a_overview_gmv_transform'),
                type: 'bar',
                stack: 'gmv',
                barMaxWidth: 10,
                data: receptionSeries,
                itemStyle: {
                    color: '#FFB72C',
                    borderRadius: [
                        4,
                        4,
                        0,
                        0
                    ]
                }
            }
        ]
    };
};
